import React, { useEffect } from "react";
import { Box } from "@mui/material";
import PageContent from "./partials/PageContent";
import PageHeader from "./partials/PageHeader";
import SEO from "../../common/SEO";
import AOS from "aos";

const PageAirSolution = ({ pageAirData }) => {
  useEffect(() => {
    AOS.init({ duration: 800, offset: 100 });
  }, []);

  const { title = "End to end Aéreos", description = "", content = "", image = null } =
    pageAirData.page_air || {};

  return (
    <Box className="solution-page" id="page-air">
      <SEO 
        title="Motor de Aéreos B2B | Búsqueda y reserva con contenido NDC/GDS — E2E"
        description="Motor de aéreos para empresas de turismo: filtros avanzados, matriz ±3 días, branded fares y contenido NDC/GDS. Optimiza conversión y operación."
      />
      <PageHeader
        title={title}
        next="End to End Hoteles"
        hrefNext="/solutions/hotels"
      />
      <PageContent
        content={content}
        title={title}
        description={description}
        image={image}
      />
    </Box>
  );
};

export default PageAirSolution;
